import React, { Fragment, useContext, useEffect, useState } from "react";
import { t } from 'i18next';

import {
    Row,
    Col,
	Form,
	Modal,
	Input,
	Label,
	Button,
	ModalBody,
	ModalHeader,
	FormFeedback,
    Card,
    CardTitle,
    Spinner,
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";

import Select from 'react-select'
import classnames from 'classnames';

import useApi from "@hooks/useApi";
import useLoader from "@hooks/useLoader";

import { ReactSelectStylesLesson } from "@utils"
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from '@context/AuthContext'
import { validate } from "@utils"
import { useSkin } from "@hooks/useSkin"
import { validateSchema } from './validateSchema';

import './style.scss'
import TimeSchedule from "../../../Home/TimeSchedule";

export default function Choose() {

    const { userDetail } = useContext(AuthContext)
    const { skin } = useSkin()

    const location = useLocation()
    const lessonId = location?.state?.lessonId || ''
    const studentId = location?.state?.studentId || userDetail?.student?.id

    // const { control, handleSubmit, reset, setError, formState: { errors } } = useForm();
    const { control, handleSubmit, reset, setError, formState: { errors } } = useForm(validate(validateSchema));

    const addChoice = false
    // {isOpen, handleModal, onSubmit, lessonId, setLessonId, studentId, addChoice=false}

    const [datas, setDatas] = useState([])
    const navigate = useNavigate()

    const [lessonOption, setLessonOption] = useState([])
    const [lektsOption, setLektsOption] = useState([])
    const [semOption, setSemOption] = useState([])
    const [labOption, setLabOption] = useState([])
    const [prakOption, setPrakOption] = useState([])
    const [isTimetable, setIsTimetable] = useState(false)

    const [chosenLesson, setChosenLesson] = useState(lessonId)

    const [lektsId, setLektsId] = useState('')
    const [semId, setSemId] = useState('')
    const [labId, setLabId] = useState('')
    const [prakId, setPrakId] = useState('')

    const [teacherId, setTeacherId] = useState('')
    const { Loader, isLoading, fetchData } = useLoader({})
    const {
        isLoading: postLoading,
        fetchData: postFetch
    } = useLoader({})

    const choiceApi = useApi().surgalt

    async function getDatas() {
        const {success, data} = await fetchData(choiceApi.getChoice(chosenLesson))
        if (success) {
            const { datas, is_timetable } = data
            setDatas(datas)
            setIsTimetable(is_timetable)
        }
    }

    async function getLessonDatas() {
        const {success, data} = await fetchData(choiceApi.getChoiceLesson(studentId))
        if (success) {
            // if (!addChoice) {
            //     var one_lesson = data.filter((c) => c.id === lessonId)
            //     setLessonOption(one_lesson)
            // } else {
            //     setLessonOption(data)
            // }
            setLessonOption(data)
        }
    }

    useEffect(
        () =>
        {
            if (chosenLesson) getDatas()
        },
        [chosenLesson]
    )

    useEffect(
        () =>
        {
            getLessonDatas()
        },
        []
    )

    async function onSubmit(cdata) {
        var ids = []
        if (lektsId) {
            ids.push(lektsId)
        }
        if (semId) {
            ids.push(semId)
        }
        if (labId) {
            ids.push(labId)
        }
        if (prakId) {
            ids.push(prakId)
        }

        const { success, data } = await postFetch(choiceApi.postChoice(ids))
        if (success) {
            // navigate(`/study-plan`)
        }
    }

    return (
        <Fragment>
            <Card className="p-1" tag={Form} onSubmit={handleSubmit(onSubmit)}>
                {
                    isTimetable
                    ?
                        <Fragment>
                            <CardTitle>
                                <h4>
                                    {t('Хичээл сонголт хийх')}
                                </h4>
                            </CardTitle>
                            <div>
                                <div className="d-flex justify-content-between flex-wrap">
                                    <div className="select_style">
                                        <Controller
                                            defaultValue=''
                                            control={control}
                                            id="lesson"
                                            name="lesson"
                                            render={({ field: { value, onChange} }) => {
                                            return (
                                                <>
                                                    <Label className="form-label" for="lesson">
                                                        {t('Хичээл')}
                                                    </Label>
                                                    <Select
                                                        name="lesson"
                                                        id="lesson"
                                                        classNamePrefix='select'
                                                        isClearable
                                                        className={classnames('react-select')}
                                                        isLoading={isLoading}
                                                        placeholder={t(`-- Сонгоно уу --`)}
                                                        options={lessonOption || []}
                                                        value={lessonOption.find((c) => c.id === chosenLesson)}
                                                        noOptionsMessage={() => t('Хоосон байна.')}
                                                        // isDisabled={!addChoice}
                                                        onChange={(val) => {
                                                            if (val?.id) {
                                                                onChange(val?.id || '')
                                                                setChosenLesson(val?.id || '')
                                                            } else {
                                                                onChange(val?.id || '')
                                                                setLektsOption([])
                                                                setSemOption([])
                                                                setLabOption([])
                                                                setPrakOption([])
                                                                setTeacherId('')
                                                                setChosenLesson('')
                                                                // setTeacherId('')
                                                            }
                                                        }}
                                                        styles={ReactSelectStylesLesson(skin)}
                                                        getOptionValue={(option) => option.id}
                                                        getOptionLabel={(option) => option.name}
                                                    />
                                                </>
                                                )
                                            }}
                                        />
                                        {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                                    </div>
                                    <div className="select_style">
                                        <Controller
                                            defaultValue=''
                                            control={control}
                                            id="teacher"
                                            name="teacher"
                                            render={({ field: { value, onChange} }) => {
                                            return (
                                                <>
                                                <Label className="form-label" for="teacher">
                                                    {t('Багш')}
                                                </Label>
                                                <Select
                                                    name="teacher"
                                                    id="teacher"
                                                    classNamePrefix='select'
                                                    isClearable
                                                    className={classnames('react-select')}
                                                    isLoading={isLoading}
                                                    placeholder={t(`-- Сонгоно уу --`)}
                                                    options={datas || []}
                                                    // options={datas?.teacher || []}
                                                    // value={datas?.teacher?.find((c) => c.id === teacherId) || ''}
                                                    value={datas?.find((c) => c.id === teacherId) || ''}
                                                    // value={datas?.teacher?.find((c) => c.id === teacherId)}
                                                    noOptionsMessage={() => t('Хоосон байна.')}
                                                    onChange={(val) => {
                                                        if (val?.id) {
                                                            onChange(val?.id || '')
                                                            setTeacherId(val?.id || '')
                                                            setLektsOption(val?.lekts)
                                                            setSemOption(val?.seminar)
                                                            setLabOption(val?.laborator)
                                                            setPrakOption(val?.practic)
                                                        } else {
                                                            setLektsOption([])
                                                            setSemOption([])
                                                            setLabOption([])
                                                            setPrakOption([])
                                                            setTeacherId(val?.id || '')
                                                        }
                                                    }}
                                                    styles={ReactSelectStylesLesson(skin)}
                                                    getOptionValue={(option) => option.id}
                                                    getOptionLabel={(option) => option.name}
                                                />
                                                </>
                                                )
                                            }}
                                        />
                                        {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                                    </div>
                                    <div className="select_style">
                                        <Controller
                                            defaultValue=''
                                            control={control}
                                            id="lekts"
                                            name="lekts"
                                            render={({ field: { value, onChange} }) => {
                                            return (
                                                <>
                                                    <Label className="form-label" for="lekts">
                                                        {t('Лекц')}
                                                    </Label>
                                                    <Select
                                                        name="lekts"
                                                        id="lekts"
                                                        classNamePrefix='select'
                                                        isClearable
                                                        className={classnames('react-select')}
                                                        isLoading={isLoading}
                                                        // isDisabled={!lektsOption?.is_timetable}
                                                        placeholder={t(`-- Сонгоно уу --`)}
                                                        options={lektsOption || []}
                                                        value={lektsOption?.find((c) => c.id === lektsId)}
                                                        noOptionsMessage={() => t('Хоосон байна.')}
                                                        onChange={(val) => {
                                                            onChange(val?.time_id || '')
                                                            setLektsId(val?.time_id || '')
                                                        }}
                                                        styles={ReactSelectStylesLesson(skin)}
                                                        getOptionValue={(option) => option.time_id}
                                                        getOptionLabel={(option) => option.isDisabled ? `${option.time_day} (дүүрсэн)` : option.time_day }
                                                    />
                                                </>
                                                )
                                            }}
                                        />
                                        {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                                    </div>
                                    <div className="select_style">
                                        <Controller
                                            defaultValue=''
                                            control={control}
                                            id="seminar"
                                            name="seminar"
                                            render={({ field: { value, onChange} }) => {
                                            return (
                                                <>
                                                    <Label className="form-label" for="seminar">
                                                        {t('Семинар')}
                                                    </Label>
                                                    <Select
                                                        name="seminar"
                                                        id="seminar"
                                                        classNamePrefix='select'
                                                        isClearable
                                                        className={classnames('react-select')}
                                                        isLoading={isLoading}
                                                        // isDisabled={!semOption?.is_timetable}
                                                        placeholder={t(`-- Сонгоно уу --`)}
                                                        options={semOption || []}
                                                        value={semOption?.find((c) => c.id === semId) || ''}
                                                        noOptionsMessage={() => t('Хоосон байна.')}
                                                        onChange={(val) => {
                                                            setSemId(val?.time_id || '')
                                                        }}
                                                        styles={ReactSelectStylesLesson(skin)}
                                                        getOptionValue={(option) => option.time_id}
                                                        getOptionLabel={(option) => option.isDisabled ? `${option.time_day} (дүүрсэн)` : option.time_day }
                                                    />
                                                </>
                                                )
                                            }}
                                        />
                                        {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                                    </div>
                                    <div className="select_style">
                                        <Controller
                                            defaultValue=''
                                            control={control}
                                            id="lab"
                                            name="lab"
                                            render={({ field: { value, onChange} }) => {
                                            return (
                                                <>
                                                    <Label className="form-label" for="lab">
                                                        {t('Лаборатор')}
                                                    </Label>
                                                    <Select
                                                        name="lab"
                                                        id="lab"
                                                        classNamePrefix='select'
                                                        isClearable
                                                        className={classnames('react-select')}
                                                        isLoading={isLoading}
                                                        isDisabled={!labOption?.is_timetable}
                                                        placeholder={t(`-- Сонгоно уу --`)}
                                                        options={labOption || []}
                                                        value={labOption?.find((c) => c.id === labId) || ''}
                                                        noOptionsMessage={() => t('Хоосон байна.')}
                                                        onChange={(val) => {
                                                            setLabId(val?.time_id || '')
                                                        }}
                                                        styles={ReactSelectStylesLesson(skin)}
                                                        getOptionValue={(option) => option.time_id}
                                                        getOptionLabel={(option) => option.isDisabled ? `${option.time_day} (дүүрсэн)` : option.time_day }
                                                    />
                                                    </>
                                                )
                                            }}
                                        />
                                        {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                                    </div>
                                    <div className="select_style">
                                        <Controller
                                            defaultValue=''
                                            control={control}
                                            id="praktic"
                                            name="praktic"
                                            render={({ field: { value, onChange} }) => {
                                            return (
                                                <>
                                                    <Label className="form-label" for="praktic">
                                                        {t('Практик')}
                                                    </Label>
                                                    <Select
                                                        name="praktic"
                                                        id="praktic"
                                                        classNamePrefix='select'
                                                        isClearable
                                                        className={classnames('react-select')}
                                                        isLoading={isLoading}
                                                        isDisabled={!prakOption?.length > 0}
                                                        placeholder={t(`-- Сонгоно уу --`)}
                                                        options={prakOption?.time_option || []}
                                                        value={prakOption?.time_option?.find((c) => c.id === prakId) || ''}
                                                        noOptionsMessage={() => t('Хоосон байна.')}
                                                        onChange={(val) => {
                                                            setPrakId(val?.time_id || '')
                                                        }}
                                                        styles={ReactSelectStylesLesson(skin)}
                                                        getOptionValue={(option) => option.time_id}
                                                        getOptionLabel={(option) => option.isDisabled ? `${option.time_day} (дүүрсэн)` : option.time_day }
                                                    />
                                                </>
                                                )
                                            }}
                                        />
                                        {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                                    </div>
                                </div>

                                <Col md={12} className="text-center mt-2">
                                    <Button className="me-2 px-1" color="primary" type="submit">
                                        <span className="p-25">
                                            {t('Хадгалах')}
                                        </span>
                                    </Button>
                                </Col>
                            </div>
                        </Fragment>
                    :
                        <div className="text-center mt-5">
                            <h5>{'Хичээл сонголт эхлээгүй байна...'}</h5>
                        </div>
                }
            </Card>
            {
                isTimetable
                &&
                <Card className="p-1" style={{ maxHeight: '50dvh' }}>
                    <TimeSchedule />
                </Card>
            }
        </Fragment>
    )
}